module.exports = __webpack_public_path__ + "img/1436328039.82f5a5d6.jpg";